import axiosInstance from '../utils/axiosInstance';

/**
 * Fetches alternate products from the API.
 *
 * @param {number} currentPage - The current page number for pagination.
 * @param {number} pageSize - The number of items per page.
 * @param {string} searchQuery - The search term to filter products.
 * @returns {Promise<Object>} The response data containing alternate products.
 */
export const getAlternateProducts = async (
  page,
  size,
  search,
  sortField,
  sortDirection,
) => {
  const response = await axiosInstance.get(
    `/SmartProAPI/api/alternate-products?page=${page}&size=${size}&searchTerm=${search}&sortBy=${sortField}&sortDir=${sortDirection}`,
  );
  if (response.status === 204) {
    return ['No data found'];
  }
  return response.data;
};

export const createNewAlternateProduct = async (productData) => {
  const response = await axiosInstance.post(
    '/SmartProAPI/api/alternate-products',
    productData,
  );
  return response.data;
};

export const deleteAlternateProduct = async (id) => {
  const response = await axiosInstance.delete(
    `/SmartProAPI/api/alternate-products/main/${id}`,
  );
  return response.data;
};

export const updateAlternateProduct = async (productData) => {
  const response = await axiosInstance.post(
    `/SmartProAPI/api/alternate-products/update`,
    productData,
  );
  return response.data;
};

export const getAlternateProductById = async (id) => {
  const response = await axiosInstance.get(
    `/SmartProAPI/api/alternate-products/main/${id}`,
  );
  return response.data;
};
